import React from "react";
import { Label } from "semantic-ui-react";

const EventStatusLabel = ({ status, ...props }) => (
  <Label {...props} basic content={status} size="large" />
);

export default EventStatusLabel;
